window.VH = window.VH === undefined ? {} : window.VH;
VH.ComSelect = {
  init: function init(corporationSelector, entitySelector) {
    let _t = VH.ComSelect,
      cParams = {
        classNames: {
          containerOuter: 'choices coms',
        },
        allowHTML: false,
      },

      corporation = $(corporationSelector),
      corporationTs = new Choices(corporation[0], {
        classNames: {
          containerOuter: 'choices coms company-select',
        },
        allowHTML: false,
      }),

      entity = $(entitySelector),
      entityTs = new Choices(entity[0], {
        classNames: {
          containerOuter: 'choices coms com-object-select',
        },
        allowHTML: false,
      })
    ;

    corporation.on('change', function () {
      $.post(corporation.data('object-list-url'), {comCorporation: corporation.val()}, function (data) {
        let options = [],
          guid,
          len = 0;
        // console.log([data.items.length, data.items]);

        // example.setChoices(
        //   [
        //     { value: 'One', label: 'Label One', disabled: true },
        //     { value: 'Two', label: 'Label Two', selected: true },
        //     { value: 'Three', label: 'Label Three' },
        //   ],
        //   'value',
        //   'label',
        //   false,
        // );

        // console.log([data]);

        for (guid in data.items) {
          options.push({
            value: guid,
            label: data.items[guid],
            selected: false,
          });
        }
        entityTs.clearChoices();
        entityTs.setChoices(options, 'value', 'label', true);
        entityTs.removeActiveItems();
        if (options.length === 1) {
          entityTs.setChoiceByValue(options[0]['value']);
        }
        else {
          entityTs.showDropdown();
        }

        corporation.closest('.choices').attr('title', corporation.find(':selected').text());

        // entity.html(options);
        // entityTs.clear();
        // entityTs.clearOptions();
        // entityTs.clearCache();
        // entityTs.sync();
        // entityTs.refreshOptions();
        // // corporationTs.close();
        //
        // if (len === 1) {
        //     entityTs.setValue(guid, true);
        //     // corporationTs.close();
        // }
      });
    });

    corporation.closest('.choices').attr('title', corporation.find(':selected').text());

    entity.closest('.choices').attr('title', entity.find(':selected').text());
    entity.on('change', function () {
      entity.closest('.choices').attr('title', entity.find(':selected').text());
    });

  },
};
